const BADGE_STORAGE_KEY = 'notifications_unread_badge_count';
const BADGE_EVENT = 'notifications-badge-change';

const emitBadgeChange = (count) => {
  window.dispatchEvent(
    new CustomEvent(BADGE_EVENT, {
      detail: { count }
    })
  );
};

export const getUnreadBadgeCount = () => {
  const rawValue = window.localStorage.getItem(BADGE_STORAGE_KEY);
  const parsedValue = Number.parseInt(rawValue || '0', 10);

  return Number.isNaN(parsedValue) ? 0 : Math.max(parsedValue, 0);
};

export const setUnreadBadgeCount = (count) => {
  const safeCount = Math.max(0, Number.parseInt(count, 10) || 0);

  window.localStorage.setItem(BADGE_STORAGE_KEY, String(safeCount));
  emitBadgeChange(safeCount);

  if ('setAppBadge' in navigator && typeof navigator.setAppBadge === 'function') {
    if (safeCount > 0) {
      navigator.setAppBadge(safeCount).catch(() => {});
    } else if ('clearAppBadge' in navigator && typeof navigator.clearAppBadge === 'function') {
      navigator.clearAppBadge().catch(() => {});
    }
  }

  return safeCount;
};

export const incrementUnreadBadge = (amount = 1) => {
  const nextCount = getUnreadBadgeCount() + Math.max(amount, 0);
  return setUnreadBadgeCount(nextCount);
};

export const clearUnreadBadge = () => {
  return setUnreadBadgeCount(0);
};

export const subscribeToBadgeChanges = (listener) => {
  const handler = (event) => {
    listener(event.detail?.count ?? 0);
  };

  window.addEventListener(BADGE_EVENT, handler);

  return () => {
    window.removeEventListener(BADGE_EVENT, handler);
  };
};
